export default "__VITE_ASSET__f521e1e4__"